import {Injectable} from "@angular/core";
import {NestApiProvider} from "../../nest-api";
import {Observable} from "rxjs";
import {RequestSavePrivacyDto, ResponseGetDataPrivacyDto, ResponseSavePrivacyDto} from "../dto/sf-change-privacies.dto";

@Injectable()
export class SfChangePrivaciesApi {
  private service: string = '';
  private model: string = 'SFChangePrivacies';

  constructor(
    private nestApiProvider: NestApiProvider
  ) {
  }


  public getDataPrivacy(): Observable<ResponseGetDataPrivacyDto> {
    const method: string = 'GET';
    const func: string = 'getDataPrivacy';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetDataPrivacyDto>(method, url, func, params, body);
  }

  public savePrivacy(data: RequestSavePrivacyDto): Observable<ResponseSavePrivacyDto> {
    const method: string = 'POST';
    const func: string = 'savePrivacy';
    const params: RequestSavePrivacyDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSavePrivacyDto>(method, url, params, urlParams, body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/sf-change-privacies.api.ts